export type stagesType = "development" | "production";

export const STAGE: stagesType =
  (process.env.REACT_APP_STAGE as stagesType) || "development";

export const API_URL = process.env.REACT_APP_API_URL || "";
